import { render } from "./ClusterLink.vue?vue&type=template&id=79b2147c&scoped=true"
import script from "./ClusterLink.vue?vue&type=script&lang=js"
export * from "./ClusterLink.vue?vue&type=script&lang=js"

import "./ClusterLink.vue?vue&type=style&index=0&id=79b2147c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b2147c"]])

export default __exports__